import { render, staticRenderFns } from "./SlcSortOptions.vue?vue&type=template&id=73c55cf2&"
import script from "./SlcSortOptions.vue?vue&type=script&lang=ts&"
export * from "./SlcSortOptions.vue?vue&type=script&lang=ts&"
import style0 from "./SlcSortOptions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports